export const KeyCode = {
  BACKSPACE: 'Backspace',
  TAB: 'Tab',
  ENTER: 'Enter',
  SHIFT: 'ShiftLeft', // or 'ShiftRight'
  CTRL: 'ControlLeft', // or 'ControlRight'
  ESCAPE: 'Escape',
  SPACE: ' ',
  DELETE: 'Delete',
  PAGE_UP: 'PageUp',
  PAGE_DOWN: 'PageDown',
  END: 'End',
  HOME: 'Home',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_UP: 'ArrowUp',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_DOWN: 'ArrowDown',
  CUT: 'KeyX',
  COPY: 'Copy',
  PASTE: 'Paste',
};

export enum Nile_Events {
  NILE_INIT = "nile-init",
  NILE_CHANGE = "nile-change",
  NILE_DESTROY = "nile-destroy", 
  NILE_PASTE = "nile-paste",
  NILE_CUT = "nile-cut",
  NILE_COPY = "nile-copy",
  NILE_SELECT_ALL = "nile-select-all",
  NILE_FOCUS = "nile-focus",
  NILE_BLUR = "nile-blur",
  NILE_INVALID = "nile-invalid",
  NILE_VALID = "nile-valid",
  NILE_RESET = "nile-reset",
  NILE_CLEAR = "nile-clear",
  NILE_CLEAR_ALL = "nile-clear-all",
  NILE_CLEAR_SELECTION = "nile-clear-selection",
  NILE_CLEAR_ALL_SELECTION = "nile-clear-all-selection",
  NILE_INPUT = "nile-input",
  NILE_COMPLETE = "nile-complete",
}

export enum MouseKey {
  META = 'metaKey',
  CTRL = 'ctrlKey',
  SHIFT = 'shiftKey',
  ALT = 'altKey',
}
